export enum DialerTypes {
  none = 'none',
  cyclic = 'cyclic',
  sequential = 'sequential',
  grouped = 'grouped',
}
